import { createToast } from '@maui/elements'
import { useCreateNotificationMutation, useUpdateNotificationMutation } from '@nautilusjs/mati-apis'
import { useAuthProvider } from '@maui-mf/common-react'

export const transformParams = (data) => {
  const renderConfig = () => {
    const { reportTypes, riskRatings, profileId } = data || {}

    const config = {}
    if (reportTypes) {
      const adjustedTypes = reportTypes.includes('All') ? [] : reportTypes
      config.mandiantReport = { reportType: adjustedTypes }
    }
    if (riskRatings) {
      const validateSeverity = riskRatings.filter(v => !v.includes('All'))
      config.mandiantVulnerability = { severity: validateSeverity }
    }
    if (profileId) {
      config.threat_profile_digest = { profile_id: profileId }
    }
    return config
  }

  const hourlySchedule = [
    {
      startTimes: [
        { hours: 0 },
        { hours: 1 },
        { hours: 2 },
        { hours: 3 },
        { hours: 4 },
        { hours: 5 },
        { hours: 6 },
        { hours: 7 },
        { hours: 8 },
        { hours: 9 },
        { hours: 10 },
        { hours: 11 },
        { hours: 12 },
        { hours: 13 },
        { hours: 14 },
        { hours: 15 },
        { hours: 16 },
        { hours: 17 },
        { hours: 18 },
        { hours: 19 },
        { hours: 20 },
        { hours: 21 },
        { hours: 22 },
        { hours: 23 }
      ],
      days: ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'],
      location: data.timeZone,
    }
  ]

  const payload = {
    config: renderConfig(),
    displayName: data.name,
    enableJob: true,
    name: data.path,
    type: data.type,
    schedules: data.deliveryFreq === 'HOURLY'
      ? hourlySchedule
      : [{
          startTimes: [{ hours: data.deliveryTime, minutes: 0 }],
          days: data.deliveryDays,
          location: data.timeZone
        }],
    recipients: [{ address: data.emailAddress }],
    owners: [data.emailAddress]
  }
  return payload
}

export const useNotifications = ({ onClose, data }) => {
  const auth = useAuthProvider()
  const orgId = auth?.claims.org

  const { mutate: createNotification, isLoading: isCreating, error: createError } = useCreateNotificationMutation({
    onSuccess: () => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: 'Notification digest created successfully',
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error creating your notification; please try again',
        duration: 15000
      })
    }
  })

  const { mutate: updateNotification, isLoading: isUpdating, error: updateError } = useUpdateNotificationMutation({
    onSuccess: () => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: 'Notification digest updated successfully',
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error updating your profile; please try again',
        duration: 15000
      })
    }
  })

  const onSubmit = (dirtyFields) => (data) => {
    const path = data?.path
    const payload = transformParams(data)
    if (path) {
      updateNotification({ path, payload, dirtyFields })
    } else {
      createNotification({ orgId, payload })
    }
  }
  const isSubmitting = isCreating || isUpdating
  const error = createError || updateError

  return {
    onSubmit,
    isSubmitting,
    error,
  }
}
